import { CloseOutlined } from '@mui/icons-material';
import { SxProps, Theme, Typography } from '@mui/material';
import { DatePicker } from 'app/components/elements/DatePicker';
import {
  FILTER_DATE_MIN_WIDTH,
  FILTER_SELECT_MIN_WIDTH,
  FilterBar,
  FilterField
} from 'app/components/elements/FilterBar';
import { InputSelect } from 'app/components/elements/InputSelect';
import { ListOptions } from 'app/pages/RoomReportViewPhotoPage/hook';
import { maintainanceName } from 'const/option';
import dayjs from 'dayjs';
import React, { useMemo } from 'react';
import styles from './styles.module.css';
import { SearchType } from 'types/loctions';

interface IProps {
  options: ListOptions;
  maintainanceSelectedType: string;
  setSelectedMaintainenceType: (value: string) => void;
  maintainanceSelectedDate?: string;
  setMaintenanceSelectedDate: (value: string) => void;
  style?: React.CSSProperties;
  inputSelectStyle?: React.CSSProperties;
  dateStyle?: SxProps<Theme> & { height?: number };
  searchType: SearchType;
  setSearchType: React.Dispatch<React.SetStateAction<SearchType>>;
}

const filterLabelSx = {
  fontWeight: 700,
  color: '#226AAA',
  whiteSpace: 'nowrap',
  mb: '10px',
  display: 'block'
} as const;

const MaintainenceFilter = ({
  options,
  maintainanceSelectedType,
  maintainanceSelectedDate,
  setMaintenanceSelectedDate,
  setSelectedMaintainenceType,
  style,
  inputSelectStyle,
  dateStyle,
  searchType,
  setSearchType
}: IProps) => {
  const maintainenceOptions = useMemo(() => {
    const listMaintainenceOption = options?.find((op) => op.name === maintainanceName);
    const dropdownValues = [...(listMaintainenceOption?.dropdownValues || [])];
    dropdownValues?.unshift({
      value: 'All',
      name: '',
      id: 0
    });
    return dropdownValues;
  }, [options]);

  const optionSearchType = [
    { label: 'Partial Text', value: 'partial-text' },
    { label: 'Full text', value: 'full-text' }
  ];

  return (
    <FilterBar sx={style}>
      {maintainenceOptions?.length > 0 && (
        <FilterField minWidth={FILTER_SELECT_MIN_WIDTH}>
          <Typography component="span" sx={filterLabelSx}>
            Maintenance Type
          </Typography>
          <InputSelect
            value={maintainanceSelectedType}
            style={inputSelectStyle}
            onChange={(e) => setSelectedMaintainenceType(e.target.value as string)}
            options={
              maintainenceOptions?.map((item) => ({
                label: item.value,
                value: item.value
              })) || []
            }
            placeholder={`Select Maintenance Type`}
          />
        </FilterField>
      )}

      <FilterField minWidth={FILTER_DATE_MIN_WIDTH} sx={{ position: 'relative' }}>
        <DatePicker
          value={maintainanceSelectedDate ? dayjs(maintainanceSelectedDate) : null}
          dateStyle={dateStyle}
          titleStyle={{ color: '#226AAA', fontWeight: '700' }}
          onChange={(val) => val && setMaintenanceSelectedDate(val?.toISOString())}
          title={'Last Maintenance Date'}
        />
        {maintainanceSelectedDate && (
          <CloseOutlined
            className={styles.reset_date}
            style={{ marginBottom: (dateStyle?.height || 56) / 2 - 10 }}
            onClick={() => {
              setMaintenanceSelectedDate('');
            }}
          />
        )}
      </FilterField>

      <FilterField minWidth={FILTER_SELECT_MIN_WIDTH}>
        <Typography component="span" sx={filterLabelSx}>
          Search Type
        </Typography>
        <InputSelect
          value={searchType}
          style={inputSelectStyle}
          onChange={(e) => setSearchType(e.target.value as SearchType)}
          options={optionSearchType}
        />
      </FilterField>
    </FilterBar>
  );
};

export default MaintainenceFilter;
